import { PlatformAppUiSchema } from '@typings';

export const isSchemaAnyOf = (
  schema: PlatformAppUiSchema.Model,
): schema is PlatformAppUiSchema.AnyOf =>
  schema.type === PlatformAppUiSchema.Type.AnyOf;

export const isSchemaContainer = (
  schema: PlatformAppUiSchema.Model,
): schema is PlatformAppUiSchema.Container =>
  schema.type === PlatformAppUiSchema.Type.Container;

export const isSchemaField = (
  schema: PlatformAppUiSchema.Model,
): schema is PlatformAppUiSchema.Field =>
  schema.type === PlatformAppUiSchema.Type.Field;

export const isSchemaArray = (
  schema: PlatformAppUiSchema.Model,
): schema is PlatformAppUiSchema.Array =>
  schema.type === PlatformAppUiSchema.Type.Array;

export const isSchemaWithChildren = (
  model: PlatformAppUiSchema.Model,
): model is PlatformAppUiSchema.ModelWithChildren => {
  return ![
    PlatformAppUiSchema.Type.Field,
    PlatformAppUiSchema.Type.Array,
  ].includes(model.type);
};
